import { INetHandler } from './IMNetHandler';
import { net } from './pb';
import C2S from './IMC2S';
import GameSocket from './IMGameSocket';
import StringUtils from './IMStringUtils';
import SingleCountEmitter, { IMEvent } from './IMEventEmitter';
import IMApp from './IMApp';
import IMApis from './IMApis';
import IMPinyin from './IMPinyin'
import IMUsers from './IMUsers';
import MessageType from './IMMessageType'
import IMConversation from './IMConversation';
import IMGroups from './IMGroups';
import IMMessage from './IMMessage';
import IMEventEmitter from './IMEventEmitter';
import { ms } from 'date-fns/locale';
import AppData from '../model/AppData';



export default class IMS2C extends INetHandler {
  name() {
    return 'IMS2C';
  }

  array = [];
  index = 0;
  lastTime = 0;

  constructor() {
    super();
  }

  handle(cmd, body, uin) {
    // console.log(cmd);
    IMApp.is15None = false;
    if (cmd != net.CLIENT_MSG_ID.C2S_MSG_HEART) {
    } else {
      this.testHeart(body, uin);
      return true;
    }
    this.handleReal(cmd, body, uin);
  }

  handleReal(cmd, body, uin) {
    switch (cmd) {
      case net.CLIENT_MSG_ID.S2C_MSG_LOGIN_REP:
        this.msg_login_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_H5LOGIN_REP:
        this.msg_h5login_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_PCLOGIN_REP:
        this.msg_pclogin_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_USER_INFO:
        this.msg_user_data_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_GET_USER_INFO_REP:
        this.msg_get_user_info_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_ADD_FRIEND_REP:
        this.msg_add_friend_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_FRIEND_APPLY_LIST_REP:
        this.msg_friend_apply_list_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_HANDLE_FRIEND_APPLY_REP:
        this.msg_handle_friend_apply_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_FRIEND_LIST_REP:
        this.msg_friend_list_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_SEND_GROUP_MSG_REP:
        this.msg_send_private_msg_rep(body, true);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_SEND_PRIVATE_MSG_REP:
        this.msg_send_private_msg_rep(body, false);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_GET_MSG_LIST_REP:
        this.msg_get_msg_list_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_RED_NTY:
        this.msg_red_nty(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_CREATE_GROUP_CHAT_REP:
        this.msg_create_group_chat_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_LOGIN_OTHER_NTY:
        this.msg_login_other_nty(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_GROUP_BASE_NTY:
        this.msg_group_base_nty(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_GET_GROUP_INFO_REP:
        this.msg_get_group_info_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_ADD_GROUP_MEMBER_REP:
        this.msg_add_group_member_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_DEL_GROUP_MEMBER_REP:
        this.msg_del_group_member_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_MODIFY_GROUPNAME_REP:
        this.msg_modify_groupname_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_MODIFY_GROUPNOTIFY_REP:
        this.msg_modify_groupnotify_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_SET_GROUPADMIN_REP:
        this.msg_set_groupadmin_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_SET_GROUPINFO_LIMITS_REP:
        this.msg_set_groupinfo_limits_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_SET_GROUPADD_LIMITS_REP:
        this.msg_set_groupadd_limits_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_DEL_GROUPADMIN_REP:
        this.msg_del_groupadmin_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_SET_GROUPLOOK_LIMITS_REP:
        this.msg_set_grouplook_limits_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_SET_GROUPHOST_REP:
        this.msg_set_grouphost_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_GROUP_OPER_NTY:
        this.msg_group_oper_nty(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_GET_REDBAG_REP:
        this.msg_get_redbag_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_GET_REDBAG_INFO_REP:
        this.msg_get_redbag_info_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_INPUT_SYNC_REP:
        this.msg_input_sync_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_GET_ONLINE_STATE_REP:
        this.msg_get_online_state_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_GET_GROUP_ONLINE_REP:
        this.msg_get_group_online_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_SET_MUTE_NOTIFICATIONS_REP:
        this.msg_set_mute_notifications_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_SET_CHAT_ON_TOP_REP:
        this.msg_set_chat_on_top_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_GET_MUTE_NOTIFY_LIST_REP:
        this.msg_get_mute_notify_list_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_GET_CHAT_ON_TOP_LIST_REP:
        this.msg_get_chat_on_top_list_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_DEL_CHAT_MSG_REP:
        this.msg_del_chat_msg_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_DELETE_FRIEND_REP:
        this.msg_delete_friend_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_SET_SIGN_REP:
        this.msg_set_sign_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_SET_REGION_REP:
        this.msg_set_region_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_SET_HEADURL_REP:
        this.msg_set_headurl_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_SET_NAME_REP:
        this.msg_set_name_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_SET_ALIAS_REP:
        this.msg_set_alias_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_GET_ALIAS_LIST_REP:
        this.msg_getalias_list_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_TOTAL_REDBAG_RECORD_RESP:
        this.msg_total_redbag_record_resp(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_UPLOAD_ADDRESSBOOK_REP:
        this.msg_upload_addressbook_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_GET_ADDRESSBOOK_REP:
        this.msg_get_addressbook_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_HANDLE_FRIEND_NTY:
        this.msg_handle_friend_nty(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_GET_ONLINE_LIST_REP:
        this.msg_get_online_list_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_TRANSFER_ACCOUNT_REP:
        this.msg_transfer_account_rep(body);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_GET_PAY_AUTH_CODE_REP:
        this.msg_get_pay_auth_code_rep(body);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_GET_MONEY_CHANGE_LIST_REP:
        this.msg_get_money_change_list_rep(body);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_GET_MY_GOODS_REP:
        this.msg_get_my_goods_rep(body);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_CREATE_GOODS_REP:
        this.msg_create_goods_rep(body);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_GET_GOODS_REP:
        this.msg_get_goods_rep(body);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_CREATE_ORDER_REP:
        this.msg_create_order_rep(body);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_CONFIRM_ORDER_REP:
        this.msg_confirm_order_rep(body);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_GET_MY_ORDERS_REP:
        this.msg_get_my_orders_rep(body);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_GET_ORDER_INFO_REP:
        this.msg_get_order_info_rep(body);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_JOINGROUP_BYQRCODE_REP:
        this.msg_joingroup_byqrcode_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_GET_GOODS_BYID_REP:
        this.msg_get_goods_byid_rep(body);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_GET_GOODS_BYID_REP:
        this.msg_get_goods_byid_rep(body);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_WITHDRAW_CHATMSG_REP:
        this.msg_withdraw_chatmsg_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_CONFIRM_HASREAD_MSG_REP:
        this.msg_confirm_hasread_msg_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_GET_HASREAD_LIST_REP:
        this.msg_get_hasread_list_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_GET_GROUP_NICKNAME_LIST_REP:
        this.msg_get_group_nickname_list_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_SET_GROUP_NICKNAME_REP:
        this.msg_set_group_nickname_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_NEW_ORDER_NTY:
        this.msg_new_order_nty(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_CANCEL_ORDER_REP:
        this.msg_cancel_order_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_SET_ORDER_PAYTYPEID_REP:
        this.msg_set_order_paytypeid_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_GET_GOODS_DATA_REP:
        this.msg_get_goods_data_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_GET_GOODS_DETAIL_DATA_REP:
        this.msg_get_goods_detail_data_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_OPER_SHOPCOIN_REP:
        this.msg_oper_shopcoin_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_SET_SNAPCHAT_REP:
        this.msg_set_snapchat_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_GET_SNAPCHAT_LIST_REP:
        this.msg_get_snap_list_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_GET_GROUP_MEMBER_LIST_REP:
        this.msg_get_group_member_list_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_GET_SCREENSHOT_REP:
        this.msg_get_screenshot_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_SET_SCREENSHOT_REP:
        this.msg_set_screenshot_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_SET_GROUPSENDMSG_LIMIT_REP:
        this.msg_set_groupsendmsg_limit_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_GET_ORDER_INFO_BYID_REP:
        this.msg_get_order_info_byid_req(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_RATE_NTY:
        this.msg_rate_nty(body, uin);
        return true;
      case net.CLIENT_MSG_ID.SC2_MSG_SET_BLACK_LIST_REP:
        this.msg_set_black_list_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.SC2_MSG_GET_BLACK_LIST_REP:
        this.msg_get_black_list_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_THIRD_PAY_REP:
        this.msg_third_pay_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_PCAUTH_REP:
        this.msg_pcauth_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_VOICE_CALL_REP:
        this.msg_voice_call_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_OPER_VOICE_CALL_REP:
        this.msg_oper_voice_call_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_VOICE_CALL_NTY:
        this.msg_voice_call_nty(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_VOICE_DATA_NTY:
        this.msg_voice_data_nty(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_SET_FORBID_TM_REP:
        this.msg_set_forbid_tm_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_NEED_READ_GROUP_NOTIFY_REP:
        this.msg_need_read_group_notify_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_READ_GROUP_NOTIFY_REP:
        this.msg_read_group_notify_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_GET_FRIEND_INCR_LIST_REP:
        this.msg_get_friend_incr_list_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_FRIEND_STATE_NTY:
        this.msg_friend_state_nty(body, uin);
        return true;
      // case net.CLIENT_MSG_ID.S2C_MSG_GET_CHATROOM_LIST_REP:
      //   this.msg_get_chatroom_list_rep(body, uin);
      //   return true;
      // case net.CLIENT_MSG_ID.S2C_MSG_GET_CHATROOM_MEMBERS_REP:
      //   this.msg_get_chatroom_members_rep(body, uin);
      //   return true;
      // case net.CLIENT_MSG_ID.S2C_MSG_JOIN_CHATROOM_REP:
      //   this.msg_join_chatroom_rep(body, uin);
      //   return true;
      // case net.CLIENT_MSG_ID.S2C_MSG_QUIT_CHATROOM_REP:
      //   this.msg_quit_chatroom_rep(body, uin);
      //   return true;
      // case net.CLIENT_MSG_ID.S2C_MSG_SEND_CHATROOM_MSG_REP:
      //   this.msg_send_chatroom_msg_rep(body, uin);
      //   return true;
      // case net.CLIENT_MSG_ID.S2C_MSG_CHATROOM_KICKOUT_REP:
      //   this.msg_chatroom_kickout_rep(body, uin);
      //   return true;
      // case net.CLIENT_MSG_ID.S2C_MSG_CHATROOM_FORBID_REP:
      //   this.msg_chatroom_forbid_rep(body, uin);
      //   return true;
      // case net.CLIENT_MSG_ID.S2C_MSG_CHATROOM_SET_ADMIN_REP:
      //   this.msg_chatroom_admin_rep(body, uin);
      //   return true;
      // case net.CLIENT_MSG_ID.S2C_MSG_DEL_CHATROOM_MSG_REP:
      //   this.msg_del_chatroom_msg_rep(body, uin);
      //   return true;
      // case net.CLIENT_MSG_ID.S2C_MSG_JOIN_CHATROOM_NTY:
      //   this.msg_join_chatroom_nty(body, uin);
      //   return true;

      // case net.CLIENT_MSG_ID.S2C_MSG_ADD_FRIEND_BYFID_REP:
      //   this.msg_add_friend_byfid_rep(body, uin);
      //   return true;
      // case net.CLIENT_MSG_ID.S2C_MSG_GET_CHATROOM_HISTORY_MSG_REP:
      //   this.msg_get_chatroom_htstory_msg_ret(body, uin);
      //   return true;




    }
    return false;
  }





  msg_get_chatroom_htstory_msg_ret(body, uin) {
    let msgs = net.msg_get_chatroom_history_msg_rep.decode(body);
    msgs = msgs.msg_list

    for (let i = 0; i < msgs.length; i++) {
      msgs[i].content = StringUtils.decode(msgs[i].content)
      msgs[i].nickname = StringUtils.decode(msgs[i].nickname)
    }
    SingleCountEmitter.emit(IMEvent.S2C_MSG_GET_CHATROOM_HISTORY_MSG_REP, msgs);
  }


  msg_add_friend_byfid_rep(body, uin) {
    let msg = net.msg_add_friend_byfid_rep.decode(body);
    SingleCountEmitter.emit('S2C_MSG_ADD_FRIEND_BYFID_REP', msg);
  }


  msg_join_chatroom_nty(body, uin) {
    //通知xxx进入了直播间 
    var msg = net.msg_join_chatroom_nty.decode(body);
    const obj = {
      'msgtype': 999,
      'content': StringUtils.decode(msg.base_data.nickname),
      'chatkey': msg.roomkey,
      'viplevel': msg.base_data.viplevel
    }
    IMEventEmitter.emit(IMEvent.CHAT_ROOM_ZHA, obj)
  }

  msg_join_chatroom_rep(body, uin) {
    var msg = net.msg_join_chatroom_rep.decode(body);
    msg.room_info.roomname = StringUtils.decode(msg.room_info.roomname);
    msg.room_info.pic = StringUtils.decode(msg.room_info.pic);
    IMEventEmitter.emit(IMEvent.JOIN_ROOM_CHAT_REP, msg)

  }

  msg_quit_chatroom_rep(body, uin) {
    var msg = net.msg_join_chatroom_rep.decode(body);
    IMEventEmitter.emit(IMEvent.QUIT_ROOM_CHAT_REP, msg)
  }

  //聊天室撤回消息
  msg_del_chatroom_msg_rep(body, uin) {
    var msg = net.msg_del_chatroom_msg_rep.decode(body);
    // console.log(msg);
    // S2C_MSG_DEL_CHATROOM_MSG_REP
    IMEventEmitter.emit(IMEvent.S2C_MSG_DEL_CHATROOM_MSG_REP, msg)
  }

  msg_chatroom_admin_rep(body, uin) {

  }

  msg_chatroom_forbid_rep(body, uin) {

  }

  msg_chatroom_kickout_rep(body, uin) {
    var msg = net.msg_chatroom_kickout_rep.decode(body);
  }

  msg_send_chatroom_msg_rep(body, uin) {
    var msg = net.msg_send_chatroom_msg_rep.decode(body);
    let d = msg.msg_info;
    d.content = StringUtils.decode(d.content);
    d.otherid = IMApp.getOtherId(msg.msg_info.chatkey, msg.msg_info.uid);
    d.isGroup = true;
    d.nickname = StringUtils.decode(d.nickname);


    d.headurl = StringUtils.decode(d.headurl);
    d.msgState = 3;
    d.isLoaded = true;
    IMEventEmitter.emit(IMEvent.UPDATE_CONVERSATION_LIST);
    IMEventEmitter.emit(IMEvent.EVENT_MESSAGE_RECEIVED, [d]);
  }

  msg_get_chatroom_members_rep(body, uin) {
    var msg = net.msg_get_chatroom_members_rep.decode(body);
  }


  msg_get_chatroom_list_rep(body, uin) {
    var msg = net.msg_get_chatroom_list_rep.decode(body);
    IMEventEmitter.emit(IMEvent.CHAT_ROOM_LIST, msg)
  }


  testHeart(body, uin) {
    var msg = net.msg_heart_test.decode(body);
    let date = new Date();
    GameSocket.instance.timeDvl = msg.svrTime - date.getTime() / 1000 + 0.2;
    IMApp.server_time = msg.ms_time / 1000;
    IMApp.localTime = IMApp.currentTime();
  }

  msg_pclogin_rep(body, uin) {
    if (IMApp.debugOrderId) {
      C2S.msg_confirm_order('3364776113602649');
    }
    GameSocket.instance.sendCMDBuffer();
    let msg = net.msg_pclogin_rep.decode(body);
    console.log('msg_login_rep', msg);
    IMApp.server_time = msg.server_time / 1000;
    IMApp.localTime = IMApp.currentTime();
    IMApp.isPlaySound = false;
    IMApp.inputSync = {};

    if (msg.result === net.RESULT_CODE.RESULT_CODE_SUCCESS) {
      C2S.msg_getalias_list();
      C2S.msg_get_mute_notify_list();
      C2S.msg_get_chat_on_top_list();
      C2S.msg_get_snap_list();
      C2S.msg_get_black_list();
      C2S.msg_friend_list();

      //获取是否设置密码
      IMApis.getPayPasswdState((err, json) => {
        if (!err && json.ret == 0 && json.isset == 1) {
          IMApp.user.pay_pwd_flag = true;
        }
      });
    } else {
      if (msg.result == 9) {
        SingleCountEmitter.emit('S2C_MSG_LOGIN_OTHER_NTY');
      } else {
        console.log('登录失败，错误码', msg.result);
      }
      return;
    }
  }

  msg_h5login_rep(body, uin) {
    if (IMApp.debugOrderId) {
      C2S.msg_confirm_order('3364776113602649');
    }
    GameSocket.instance.sendCMDBuffer();
    let msg = net.msg_h5login_rep.decode(body);
    console.log('msg_login_rep', msg);
    IMApp.server_time = msg.server_time / 1000;
    IMApp.localTime = IMApp.currentTime();
    IMApp.isPlaySound = false;
    IMApp.inputSync = {};

    if (msg.result === net.RESULT_CODE.RESULT_CODE_SUCCESS) {
      C2S.msg_getalias_list();
      C2S.msg_get_mute_notify_list();
      C2S.msg_get_chat_on_top_list();
      C2S.msg_get_snap_list();
      C2S.msg_get_black_list();
      C2S.msg_friend_list();

      //获取是否设置密码
      IMApis.getPayPasswdState((err, json) => {
        if (!err && json.ret == 0 && json.isset == 1) {
          IMApp.user.pay_pwd_flag = true;
        }
      });
    } else {
      if (msg.result == 9) {
        SingleCountEmitter.emit('S2C_MSG_LOGIN_OTHER_NTY');
      } else {
        console.log('登录失败，错误码', msg.result);
      }
      return;
    }

  }

  /**
   * 登录返回
   * @param body
   */
  msg_login_rep(body, uin) {
    if (IMApp.debugOrderId) {
      C2S.msg_confirm_order('3364776113602649');
    }
    GameSocket.instance.sendCMDBuffer();
    let msg = net.msg_login_rep.decode(body);
    IMApp.server_time = msg.ms_time / 1000;
    IMApp.localTime = IMApp.currentTime();
    IMApp.isPlaySound = false;
    IMApp.inputSync = {};
    // console.log(msg.customer_list);
    for (let index = 0; index < msg.customer_list.length; index++) {
      if (msg.customer_list[index].customer_type == 1) {
        AppData.serverID = msg.customer_list[index].uid
        break;
      }
      // customer_type

    }

    if (msg.result === net.RESULT_CODE.RESULT_CODE_SUCCESS) {
      C2S.msg_getalias_list();
      C2S.msg_get_mute_notify_list();
      C2S.msg_get_chat_on_top_list();
      C2S.msg_get_snap_list();
      C2S.msg_get_black_list();

      //获取是否设置密码
      IMApis.getPayPasswdState((err, json) => {
        if (!err && json.ret == 0 && json.isset == 1) {
          IMApp.user.pay_pwd_flag = true;
        }
      });
    } else {
      if (msg.result == 9) {
        SingleCountEmitter.emit('S2C_MSG_LOGIN_OTHER_NTY');
      } else {
        console.log('登录失败，错误码', msg.result);
      }
      return;
    }



    // let Phone_type = Number(IMPush.getPhoneType());
    // let Phone_token = IMPush.getPhoneToken();

    // let jiguang = () => {
    //   JPush.getRegistrationID(result => { 
    //     if (!StringUtils.isEmpty(result.registerID)) {
    //       C2S.msg_upload_pushid(result.registerID, Phone_type);
    //     }
    //   });
    // };
    //Phone_type = 1;
    // if (Phone_type == 1) {
    //   //jiguang();
    // } else if (Phone_type == 2 || Phone_type == 4) {
    //   C2S.msg_upload_pushid(Phone_token, Phone_type);
    // } else if (Phone_type == 3) { 
    //   if (StringUtils.isEmpty(Phone_token)) {
    //     C2S.msg_upload_pushid(Phone_token, Phone_type);
    //     IMPush.getToken();
    //   } else {
    //     C2S.msg_upload_pushid(Phone_token, Phone_type);
    //   }
    // }

    C2S.msg_friend_list();
  }

  msg_user_data_rep(body, uin) {
    //连接了socket之后，会返回用户信息的。
    //如果页面刷新了，没有了任何数据，refreshRoom是默认状态true的。 让播放页面刷新，socket连上了

    IMEventEmitter.emit(IMEvent.REF_ROOM);



    let base_data = net.msg_user_data_rep.decode(body).base_data;
    IMApp.user.freezecoin = base_data.freezecoin;
    IMApp.user.shopcoin = base_data.shopcoin;
    IMApp.user.nickname = StringUtils.decode(base_data.nickname);
    IMApp.user.headurl = StringUtils.decode(base_data.headurl);
    IMApp.user.zone = StringUtils.decode(base_data.zone);
    IMApp.user.coin_list = base_data.coin_list;
    IMApp.user.fid = base_data.fid;
    SingleCountEmitter.emit('S2C_MSG_USER_INFO');
  }

  msg_login_other_nty(body, uin) {
    let msg = net.msg_login_other_nty.decode(body);
    let deviceid = StringUtils.decode(msg.deviceid);
    console.log('IMApp.deviceid = ', IMApp.deviceid);
    console.log('deviceid =  ', deviceid);
    // if (IMApp.deviceid != deviceid) {
    //    return;
    // }
    IMApp.isLoginOther = true;
    SingleCountEmitter.emit('S2C_MSG_LOGIN_OTHER_NTY');
  }

  msg_get_user_info_rep(body, uin) {
    let msg = net.msg_get_user_info_rep.decode(body);
    if (msg.user_info != null) {
      let users = [];
      users.push({
        uid: msg.user_info.uid,
        nickname: StringUtils.decode(msg.user_info.nickname),
        headurl: StringUtils.decode(msg.user_info.headurl),
      });
      IMUsers.addUserInfos(users);
    }
    SingleCountEmitter.emit('S2C_MSG_GET_USER_INFO_REP', IMApp.parseInfo(msg.user_info));
  }

  msg_add_friend_rep(body, uin) {
    let msg = net.msg_add_friend_rep.decode(body);
    SingleCountEmitter.emit('S2C_MSG_ADD_FRIEND_REP', msg);
  }

  msg_friend_apply_list_rep(body, uin) {

    let msg = net.msg_friend_apply_list_rep.decode(body);
    IMApp.applylist = [];
    for (let i = 0; i < msg.apply_list.length; i++) {
      let d = msg.apply_list[i];
      let hellomsg = StringUtils.decode(d.hellomsg);
      IMApp.applylist.push({
        uid: d.info.uid,
        nickname: StringUtils.decode(d.info.nickname),
        headurl: StringUtils.decode(d.info.headurl),
        hellomsg: IMPinyin.isEmpty(hellomsg) ? '请求添加您为朋友' : hellomsg,
        applyState: d.applyState,
        applytime: d.applytime,
      });
    }
    IMApp.applylist.sort((a, b) => {
      return b.applytime - a.applytime;
    });

    SingleCountEmitter.emit(IMEvent.FRIEND_APPLY_LIST);
    SingleCountEmitter.emit('S2C_MSG_RED_NTY_APPLY_NUM', 0);
  }

  msg_handle_friend_apply_rep(body, uin) {
    let msg = net.msg_handle_friend_apply_rep.decode(body);
    SingleCountEmitter.emit(IMEvent.FRIEND_APPLY_BACK, msg);
  }

  msg_friend_list_rep(body, uin) {
    let time = new Date().getTime();
    let msg = net.msg_friend_list_rep.decode(body);
    // console.log('msg_friend_list_rep', msg)
    if (msg.isfirst == 1) {
      IMApp.friendlist = [];
    }

    let ds = [];
    for (let i = 0; i < msg.flist.length; i++) {
      let d = IMApp.parseInfo(msg.flist[i]);
      ds.push(d);
      IMApp.friendlist.push(d);
    }
    if (msg.isend == 1) {
      IMApp.friendlistversion = msg.version;
      IMUsers.setFriends();
      SingleCountEmitter.emit('S2C_MSG_FRIEND_LIST_REP', msg);
    }
    IMUsers.addUserInfos(ds, msg.isend == 1);

    // console.log('time---->', new Date().getTime() - time);
  }

  msg_get_friend_incr_list_rep(body, uin) {
    let msg = net.msg_get_friend_incr_list_rep.decode(body);
    if (IMApp.friendlistversion == msg.version) {
      return;
    }
    for (let i = 0; i < msg.dellist.length; i++) {
      for (let j = IMApp.friendlist.length - 1; j >= 0; j--) {
        if (IMApp.friendlist[j].uid == msg.dellist[i]) {
          IMApp.friendlist.splice(j, 1);
          break;
        }
      }
    }

    let ds = [];
    for (let i = 0; i < msg.addlist.length; i++) {
      let isExits = false;
      for (let j = IMApp.friendlist.length - 1; j >= 0; j--) {
        if (IMApp.friendlist[j].uid == msg.addlist[i].uid) {
          isExits = true;
          break;
        }
      }
      if (isExits) {
        continue;
      }
      let d = IMApp.parseInfo(msg.addlist[i]);
      ds.push(d);
      IMApp.friendlist.push(d);
    }
    if (msg.isend == 1) {
      IMApp.friendlistversion = msg.version;
      IMUsers.setFriends();
    }
    IMUsers.addUserInfos(ds, msg.isend == 1);
    SingleCountEmitter.emit('S2C_MSG_FRIEND_LIST_REP', msg);
  }

  voice_chat(d) {
    let json = JSON.parse(d.content);
    // console.log('json--->', json, d.uid);
    if (json.duration > 0) {
      d.content = '通话时长' + StringUtils.intToTime1(json.duration);
    } else {
      if (d.uid == IMApp.user.uid) {
        if (json.operuid == d.uid) {
          d.content = '已取消';
        } else {
          d.content = '对方已拒绝';
        }
      } else {
        if (json.operuid == d.uid) {
          d.content = '对方已取消';
        } else {
          d.content = '已拒绝';
        }
      }
    }
  }

  msg_send_private_msg_rep(body, isGroup) {

    console.log('发送消息回调');

    let msg = isGroup ? net.msg_send_group_msg_rep.decode(body) : net.msg_send_private_msg_rep.decode(body);
    if (!msg.msg_info) {
      return;
    }
    let d = msg.msg_info;
    if (msg.msg_info.uid == IMApp.user.uid && msg.msg_info.msgtype == MessageType.CENTER_TIP_ORDER) {
      return;
    }
    d.clientkey = StringUtils.decode(d.clientkey);
    console.log(msg.result); 
    if (msg.result != net.RESULT_CODE.RESULT_CODE_SUCCESS) {
      if (msg.result == net.RESULT_CODE.RESULT_CODE_NOT_YOUR_FRIEND) {
        let m = IMApp.generateMsgOut(MessageType.CENTER_TIP_NEED_VERFY, '', d.chatkey);
        d.msgState = 2;
        d.chatmsgno = d.clientkey;
        IMConversation.refreshMessageByClientKey(d);
        SingleCountEmitter.emit('S2C_MSG_SEND_PRIVATE_MSG_REP', [m]);
      } else if (msg.result == net.RESULT_CODE.RESULT_CODE_IN_BLACK_LIST) {
        let m = IMApp.generateMsgOut(MessageType.CENTER_TIP, '消息已经被对方拒收', d.chatkey);
        d.msgState = 2;
        d.chatmsgno = d.clientkey;
        IMConversation.refreshMessageByClientKey(d);
        SingleCountEmitter.emit('S2C_MSG_SEND_PRIVATE_MSG_REP', [m]);
      } else {
        console.log('未知原因，发送失败');
      }
      return;
    } 
    if (msg.result == 0 || msg.result == 6) {
      //发送失败
      console.log(msg.result);
      IMEventEmitter.emit('S2C_MSG_SEND_PRIVATE_MSG_REP_ERR',msg.result);
    }

    if (d.msgtype == MessageType.VOICE_CHAT_PACKAT) {
      if (msg.result == net.RESULT_CODE.RESULT_CODE_SUCCESS) {
        let last = msg.msg_info;
        C2S.msg_confirm_read_msg(last.chatkey, last.chatmsgno);
      }
      return;
    }

    d.content = StringUtils.decode(d.content);
    if (d.msgtype == MessageType.VOICE_CHAT1) {
      this.voice_chat(d);
    }
    d.otherid = IMApp.getOtherId(msg.msg_info.chatkey, msg.msg_info.uid);
    d.isGroup = isGroup;
    d.nickname = StringUtils.decode(d.nickname);
    d.headurl = StringUtils.decode(d.headurl);
    d.msgState = 3;
    d.isLoaded = true;
    C2S.updateUnreadlist(d.chatkey, d.clientkey, d.chatmsgno);
    /** */
    console.log('msg_send_private_msg_rep', d);
    IMMessage.addOrUpdateMessage(d);
    IMConversation.updateConversationLastMessage(d);

    if (!IMUsers.isUserExist(d.uid)) {
      IMUsers.addOrUpdateUser({
        uid: d.uid,
        nickname: StringUtils.decode(d.nickname),
        headurl: StringUtils.decode(d.headurl)
      })
    }

    IMEventEmitter.emit(IMEvent.UPDATE_CONVERSATION_LIST);
    IMEventEmitter.emit(IMEvent.EVENT_MESSAGE_RECEIVED, [d]);
  }

  msg_get_msg_list_rep(body, uin) {
    let msg = net.msg_get_msg_list_rep.decode(body);

    if (msg.msg_list.length === 0) {
      return;
    }

    let conversations = [];
    let newMessages = [];
    let unreadCount = 0;
    for (let i = 0; i < msg.msg_list.length; i++) {
      let d = msg.msg_list[i];
      if (d.msgtype === MessageType.VOICE_CHAT_PACKAT) {
        continue;
      }


      d.content = StringUtils.decode(d.content);
      d.nickname = StringUtils.decode(d.nickname);
      d.headurl = StringUtils.decode(d.headurl);
      d.otherid = IMApp.getOtherId(d.chatkey, IMApp.user.uid);
      d.isGroup = IMApp.checkIsGroup(d.chatkey);
      d.clientkey = StringUtils.decode(d.clientkey);
      d.hasred = msg.hasred;
      if (d.msgtype == MessageType.SERVER_TXT) {
        d.msgtype = MessageType.TXT;
      }
      if (d.msgtype == MessageType.VOICE_CHAT1) {
        this.voice_chat(d);
      }
      /** 更新用户 */
      IMUsers.addOrUpdateUser({ uid: d.uid, nickname: d.nickname, headurl: d.headurl });
      if (!IMMessage.isMessageExist(d)) {
        newMessages.push(d);
        unreadCount++;
      }
      IMMessage.addOrUpdateMessage(d);
      /** 形成会话 */
      conversations[d.chatkey] = { conversationId: d.chatkey, isGroup: d.isGroup, }
    }

    for (const key in conversations) {
      if (Object.hasOwnProperty.call(conversations, key)) {
        let d = conversations[key];
        let otherid = IMApp.getOtherId(d.conversationId, IMApp.user.uid);
        let userProfile = null;
        let headurls = [];
        let titleName = '';
        if (d.isGroup) {
          if (d.conversationId == IMApp.user.uid) {
            userProfile = IMUsers.getUserInfo(d.conversationId);
            if (userProfile) {
              headurls.push(userProfile.headurl);
              titleName = userProfile.nickname;
            }
          } else {
            headurls = IMGroups.getGroupHeadUrls(d.conversationId)
          }
        } else {
          userProfile = IMUsers.getUserInfo(otherid);
          if (userProfile) {
            headurls.push(userProfile.headurl);
            titleName = userProfile.nickname;
          }
        }

        let conversation = {
          conversationId: d.conversationId,
          isGroup: d.isGroup,
          userProfile: userProfile,
          lastMessage: IMMessage.getConversationLastMessage(d.conversationId),
          groupInfo: d.isGroup ? IMGroups.getGroup(d.conversationId) : null,
          headurls: headurls,
          unreadCount: msg.hasred,
          titleName: '',
          lastMsgContent: '',
        }
        if (d.isGroup && d.conversationId != IMApp.user.uid) {
          titleName = IMConversation.getConversationName(conversation);
        }
        conversation.titleName = titleName;
        conversation.lastMsgContent = IMMessage.getMessageDesc(conversation.lastMessage);


        IMConversation.addOrUpdateConversation(conversation);
      }
    }


    IMEventEmitter.emit(IMEvent.UPDATE_CONVERSATION_LIST);

    IMEventEmitter.emit(IMEvent.EVENT_MESSAGE_RECEIVED, newMessages);


    //let last = msg.msg_list[msg.msg_list.length - 1];
    //C2S.msg_confirm_read_msg(last.chatkey, last.chatmsgno);
  }

  msg_red_nty(body, uin) {
    let msg = net.msg_red_nty.decode(body);
    console.log('--------新的好友申请', msg);
    let red = msg.red;
    if (red.redtype === 1 || red.redtype === 2) {
      let chatmsgno = IMMessage.getConversationLastChatMsgNo(red.chatkey)
      C2S.msg_get_msg_list(red.chatkey, chatmsgno);
    } else if (red.redtype === 3) {
      C2S.msg_get_group_info(red.chatkey);
    } else if (red.redtype === 4) {
      IMApp.unread_apply_num = red.unread_apply_num;
      SingleCountEmitter.emit('S2C_MSG_RED_NTY_APPLY_NUM', IMApp.unread_apply_num);
    }
  }

  msg_create_group_chat_rep(body, uin) {
    let msg = net.msg_create_group_chat_rep.decode(body);
    msg.is_end = 1;
    this.checkGroup(msg);
    let d = new net.chat_msg();
    d.chatkey = msg.group_info.groupkey;
    d.chatmsgno = 0;
    d.msgtime = IMApp.getCurTime();
    d.msgtype = MessageType.CENTER_TIP;
    d.isGroup = true;

    let uids = [];
    for (let i = 0; i < msg.users.length; i++) {
      let u = IMApp.parseInfo(msg.users[i]);
      uids.push(u.uid);
    }

    let names = IMUsers.getNames(uids).join(',');
    d.content = names + '加入了群聊';
    IMConversation.addMessage([d], () => {
      SingleCountEmitter.emit('S2C_MSG_CREATE_GROUP_CHAT_REP', d);
      SingleCountEmitter.emit('notifyConversationListRefresh');
    });
  }

  deleted(groupkey, group) {
    //被踢
    let chatmsgno = 0;
    if (!group) {
      let group = IMGroups.getGroup(groupkey);
      if (!group) {
        chatmsgno = group.chatmsgno + 0.5;
      }
    }
    let d = new net.chat_msg();
    d.chatkey = groupkey;
    d.chatmsgno = chatmsgno;
    d.msgtime = IMApp.getCurTime();
    d.msgtype = MessageType.CENTER_TIP;
    d.isGroup = true;
    d.content = '您已不在本群聊';
    IMConversation.addMessage([d]);
  }

  msg_group_base_nty(body, uin) {
    let msg = net.msg_group_base_nty.decode(body);
    let grouplist = msg.grouplist;

    for (let i = 0; i < IMGroups.groups.length; i++) {
      let localGroup = IMGroups.groups[i];

      let isExit = true;
      for (let j = 0; j < grouplist.length; j++) {
        if (localGroup.groupkey === grouplist[j].groupkey) {
          isExit = false;
          break;
        }
      }
      if (localGroup.isExit && isExit) {
        continue;
      }
      localGroup.isExit = isExit;
      if (isExit) {
        this.deleted(localGroup.groupkey, localGroup);
      }
    }
    IMGroups.save();
    let keys = [];
    for (let i = 0; i < grouplist.length; i++) {
      let group = IMGroups.getGroup(grouplist[i].groupkey);
      let flag1 = false; //是否拉取群资料
      let flag2 = false; //是否拉取群消息
      if (group) {
        if (group.attrversion < grouplist[i].attrversion) {
          flag1 = true;
        }
        if (group.chatmsgno < grouplist[i].chatmsgno) {
          flag2 = true;
        }
      } else {
        flag1 = true;
        flag2 = true;
      }
      if (flag1) {
        keys.push(grouplist[i].groupkey);
      } else {
        if (flag2) {
          C2S.msg_get_msg_list(grouplist[i].groupkey, group ? group.chatmsgno : 0);
        }
      }
    }
    for (let i = 0; i < keys.length; i++) {
      C2S.msg_get_group_info(keys[i], 0, i == keys.length - 1 ? 1 : 0);
    }
    SingleCountEmitter.emit('SOCKET_RECONNECTED');
  }

  msg_get_group_info_rep(body, uin) {
    let msg = net.msg_get_group_info_rep.decode(body);
    let group = this.checkGroup(msg);
    if (msg.group_info.chatmsgno > group.chatmsgno) {
      C2S.msg_get_msg_list(group.groupkey, group.chatmsgno);
    }
    if (msg.is_end == 1) {
      SingleCountEmitter.emit('notifyConversationListRefresh');
      SingleCountEmitter.emit('GROUP_INFO_CHANGE', group);
    }
  }

  checkGroup(msg) {
    // console.log('checkGroup-1->', msg);
    let groupkey = msg.group_info.groupkey;
    let group = IMGroups.getGroup(groupkey);

    let users = [];
    for (let i = 0; i < msg.users.length; i++) {
      let u = IMApp.parseInfo(msg.users[i]);
      users.push(u);
    }
    IMUsers.addUserInfos(users);
    let data = {
      groupkey: groupkey,
      users: users,
      attrversion: msg.group_info.attrversion,
      grouphost: msg.group_info.grouphost,
      groupname: StringUtils.decode(msg.group_info.groupname),
      groupnotify: StringUtils.decode(msg.group_info.groupnotify),
      groupadmins: msg.group_info.groupadmins,
      info_limits: msg.group_info.info_limits,
      add_limits: msg.group_info.add_limits,
      look_limits: msg.group_info.look_limits,
      send_msg_limits: msg.group_info.send_msg_limits,
      member_cnt: msg.group_info.member_cnt,
      notifyversion: msg.group_info.notifyversion,
      forbidbegintm: msg.group_info.forbidbegintm,
      forbidendtm: msg.group_info.forbidendtm,
      isforbid: msg.group_info.isforbid,
      isExit: false,
    };
    if (group) {
      IMGroups.refreshGroup(groupkey, data);
    } else {
      if (msg.is_stranger == 1) {
        SingleCountEmitter.emit(IMEvent.GROUP_INFO_CHANGE, data);
      } else {
        data.chatmsgno = -1;
        IMGroups.addGroup(data);
      }
    }
    if (msg.is_end == 1) {
      IMGroups.save()
    }

    return data;
  }

  msg_add_group_member_rep(body, uin) {
    let msg = net.msg_add_group_member_rep.decode(body);
    SingleCountEmitter.emit(IMEvent.ADD_GROUP_MEMBER_RESPONSE, msg);
  }

  msg_del_group_member_rep(body, uin) {
    let msg = net.msg_del_group_member_rep.decode(body);
    SingleCountEmitter.emit(IMEvent.DEL_GROUP_MEMBER_RESPONSE, msg);
  }

  msg_modify_groupname_rep(body, uin) {
    let msg = net.msg_modify_groupname_rep.decode(body);
    if (msg.result === 1) {
      SingleCountEmitter.emit('S2C_MSG_MODIFY_GROUPNAME_REP');
      console.log('修改群名成功');

      let m = net.msg_modify_groupname.decode(
        GameSocket.instance.bufferMsg[uin],
      );
      let username = IMApp.getShowNameByUID(
        IMApp.user.uid,
        IMGroups.curgroup.groupkey,
      );
      C2S.msg_send_private_msg(
        IMGroups.curgroup.groupkey,
        MessageType.CENTER_TIP,
        "'" +
        username +
        "'" +
        "修改了群名 '" +
        StringUtils.decode(m.new_name) +
        "'",
        true,
        '',
        '',
        1,
      );
    } else {
      console.log('修改群名失败');
    }
  }

  msg_modify_groupnotify_rep(body, uin) {
    let msg = net.msg_modify_groupnotify_rep.decode(body);
    if (msg.result === 1) {
      SingleCountEmitter.emit('S2C_MSG_MODIFY_GROUPNOTIFY_REP');
      console.log('修改公告成功');

      let m = net.msg_modify_groupnotify.decode(
        GameSocket.instance.bufferMsg[uin],
      );
      let username = IMApp.getShowNameByUID(
        IMApp.user.uid,
        IMGroups.curgroup.groupkey,
      );
      C2S.msg_send_private_msg(
        msg.groupkey,
        MessageType.CENTER_TIP,
        "群公告：'" + StringUtils.decode(m.new_notify) + "' --" + username,
        true,
        '',
        '',
        1,
      );
    } else {
      console.log('修改公告失败');
    }
  }

  msg_set_groupadmin_rep(body, uin) {
    let msg = net.msg_set_groupadmin_rep.decode(body);
    if (msg.result === 1) {
      console.log('添加管理员成功');
      SingleCountEmitter.emit('S2C_MSG_SET_GROUPADMIN_REP');
    } else {
      console.log('添加管理员失败');
    }
  }

  msg_set_groupinfo_limits_rep(body, uin) {
    let msg = net.msg_set_groupinfo_limits_rep.decode(body);
    if (msg.result === 1) {
      SingleCountEmitter.emit('S2C_MSG_SET_GROUPINFO_LIMITS_REP');
      console.log('权限设置成功');
    } else {
      console.log('权限设置失败');
    }
  }

  msg_set_groupadd_limits_rep(body, uin) {
    let msg = net.msg_set_groupadd_limits_rep.decode(body);
    if (msg.result === 1) {
    } else {
      console.log('群聊邀请设置失败');
    }
  }

  msg_del_groupadmin_rep(body, uin) {
    let msg = net.msg_del_groupadmin_rep.decode(body);
    if (msg.result === 1) {
      console.log('删除管理员成功');
      SingleCountEmitter.emit('S2C_MSG_DEL_GROUPADMIN_REP');
    } else {
      console.log('删除管理员失败');
    }
  }

  msg_set_grouplook_limits_rep(body, uin) {
    let msg = net.msg_set_grouplook_limits_rep.decode(body);
    if (msg.result === 1) {
      SingleCountEmitter.emit('S2C_MSG_SET_GROUPLOOK_LIMITS_REP');
      console.log('权限设置成功');
    } else {
      console.log('权限设置失败');
    }
  }

  msg_set_grouphost_rep(body, uin) {
    let msg = net.msg_set_grouphost_rep.decode(body);
    console.log('msg_set_grouphost_rep---->', msg);
    if (msg.result === 1) {
      SingleCountEmitter.emit('S2C_MSG_SET_GROUPHOST_REP');
      console.log('群主设置成功');
      let name = IMUsers.getNames([msg.uid]);
      C2S.msg_send_private_msg(
        msg.groupkey,
        MessageType.CENTER_TIP,
        "'" + name[0] + "'成为了群主",
        true,
        '',
        '',
        1,
      );
    } else {
      console.log('群主设置失败');
    }
  }

  msg_group_oper_nty(body, uin) {
    let msg = net.msg_group_oper_nty.decode(body);
    if (msg.opertype === 1) {
      //被踢
      this.deleted(msg.groupkey);
    }
  }

  msg_get_redbag_rep(body, uin) {
    let msg = net.msg_get_redbag_rep.decode(body);
    SingleCountEmitter.emit('S2C_MSG_GET_REDBAG_REP', msg);
  }

  msg_get_redbag_info_rep(body, uin) {
    let msg = net.msg_get_redbag_info_rep.decode(body);
    SingleCountEmitter.emit('S2C_MSG_GET_REDBAG_INFO_REP', msg);
  }

  msg_input_sync_rep(body, uin) {
    let msg = net.msg_input_sync_rep.decode(body);
    IMApp.inputSync[msg.chatkey] = msg.is_input;
    SingleCountEmitter.emit('S2C_MSG_INPUT_SYNC_REP', msg);
  }

  msg_get_online_state_rep(body, uin) {
    let msg = net.msg_get_online_state_rep.decode(body);
    SingleCountEmitter.emit('S2C_MSG_GET_ONLINE_STATE_REP', msg);
  }

  msg_get_group_online_rep(body, uin) {
    let msg = net.msg_get_group_online_rep.decode(body);
    SingleCountEmitter.emit('S2C_MSG_GET_GROUP_ONLINE_REP', msg);
  }

  msg_set_mute_notifications_rep(body, uin) {
    let msg = net.msg_set_mute_notifications_rep.decode(body);
    if (msg.opertype === 1) {
      let opertime = IMApp.getCurTime();
      IMApp.setValue(IMApp.muteList, msg.chatkey, opertime);
    } else {
      IMApp.removeValue(IMApp.muteList, msg.chatkey);
    }
    IMConversation.refreshConversation(msg.chatkey, true, () => {
      // SingleCountEmitter.emit('ConvarsationItem_Refresh' + msg.chatkey);
      SingleCountEmitter.emit('notifyConversationListRefresh');
      SingleCountEmitter.emit('S2C_MSG_SET_MUTE_NOTIFICATIONS_REP', msg);
    });
  }

  msg_set_chat_on_top_rep(body, uin) {
    let msg = net.msg_set_chat_on_top_rep.decode(body);
    if (msg.opertype === 1) {
      IMApp.setValue(IMApp.chatTopList, msg.chatkey, msg.opertime);
    } else {
      IMApp.removeValue(IMApp.chatTopList, msg.chatkey);
    }
    IMConversation.refreshConversation(msg.chatkey, false, () => {
      SingleCountEmitter.emit('notifyConversationListRefresh');
    });
  }

  msg_get_mute_notify_list_rep(body, uin) {
    let msg = net.msg_get_mute_notify_list_rep.decode(body);
    IMApp.muteList = msg.chatkeys;
  }

  msg_get_chat_on_top_list_rep(body, uin) {
    let msg = net.msg_get_chat_on_top_list_rep.decode(body);
    IMApp.chatTopList = msg.chatkeys;
    SingleCountEmitter.emit('login_server');
    C2S.msg_get_offline_data();
  }

  msg_del_chat_msg_rep(body, uin) {
    let msg = net.msg_del_chat_msg_rep.decode(body);
    IMApp.addDeleteMsg(msg.chatkey, msg.chatmsgno);
    C2S.msg_confirm_del_msg(msg.chatkey, msg.chatmsgno);
    // console.log('msg_del_chat_msg_rep--------->', msg.chatkey, msg.chatmsgno);
    IMConversation.deleteMsgByNO(msg.chatkey, msg.chatmsgno, () => {
      if (msg.uid == IMApp.user.uid) {
        console.log('聊天清除成功');
      }
      SingleCountEmitter.emit('notifyConversationListRefresh');
      SingleCountEmitter.emit('S2C_MSG_SEND_PRIVATE_MSG_REP', [
        { chatkey: msg.chatkey },
      ]);
    });
  }

  msg_delete_friend_rep(body, uin) {
    let msg = net.msg_delete_friend_rep.decode(body);
    SingleCountEmitter.emit('S2C_MSG_DELETE_FRIEND_REP', msg.frienduid);
  }

  msg_set_sign_rep(body, uin) {
    let msg = net.msg_set_sign_rep.decode(body);
    if (msg.result == 1) {
      IMApp.user.sign = StringUtils.decode(msg.sign);
      SingleCountEmitter.emit('S2C_MSG_USER_INFO');
      console.log('签名设置成功');
    } else {
      console.log('签名设置失败');
    }
  }

  msg_set_region_rep(body, uin) {
    let msg = net.msg_set_region_rep.decode(body);
    IMApp.user.region = StringUtils.decode(msg.region);
    SingleCountEmitter.emit('S2C_MSG_USER_INFO');
  }

  msg_set_headurl_rep(body, uin) {
    let msg = net.msg_set_headurl_rep.decode(body);
    if (msg.result == 1) {
      IMApp.user.headurl = StringUtils.decode(msg.headurl);
      SingleCountEmitter.emit('UPDATE_HEAD_URL');
      SingleCountEmitter.emit('S2C_MSG_USER_INFO');
    } else {
      console.log('头像上传失败');
    }
  }

  msg_set_name_rep(body, uin) {
    let msg = net.msg_set_name_rep.decode(body);
    if (msg.result == 1) {
      IMApp.user.nickname = StringUtils.decode(msg.name);
      SingleCountEmitter.emit('S2C_MSG_USER_INFO');
      console.log('昵称设置成功');
    } else {
      console.log('昵称无法保存');
    }
  }

  msg_set_alias_rep(body, uin) {
    let msg = net.msg_set_alias_rep.decode(body);

    if (msg.result == 1) {
      let alias = StringUtils.decode(msg.alias);
      IMApp.aliasList[msg.fuid] = alias;
      IMUsers.setAliasFriend();
      SingleCountEmitter.emit('S2C_MSG_SET_ALIAS_REP', msg);
      SingleCountEmitter.emit('S2C_MSG_SET_ALIAS_REP' + msg.fuid, alias);
      console.log('备注设置成功');
    } else {
      console.log('备注设置失败');
    }
  }

  msg_getalias_list_rep(body, uin) {
    let msg = net.msg_getalias_list_rep.decode(body);
    let alias_list = msg.alias_list;
    for (let i = 0; i < alias_list.length; i++) {
      IMApp.aliasList[alias_list[i].fuid] = StringUtils.decode(
        alias_list[i].aliasname,
      );
    }
    IMUsers.setAliasFriend();
  }

  msg_total_redbag_record_resp(body, uin) {
    let msg = net.msg_total_redbag_record_resp.decode(body);
    SingleCountEmitter.emit('S2C_MSG_TOTAL_REDBAG_RECORD_RESP', msg);
  }

  msg_upload_addressbook_rep(body, uin) {
    let msg = net.msg_upload_addressbook_rep.decode(body);
    SingleCountEmitter.emit('S2C_MSG_UPLOAD_ADDRESSBOOK_REP', msg);
  }

  msg_get_addressbook_rep(body, uin) {
    // console.log('body--->', body,uin);
    let msg = net.msg_get_addressbook_rep.decode(body);
    SingleCountEmitter.emit('S2C_MSG_GET_ADDRESSBOOK_REP', msg);
  }

  msg_handle_friend_nty(body, uin) {
    C2S.msg_friend_list();
  }

  msg_get_online_list_rep(body, uin) {
    // console.log('body--->', body,uin);
    let msg = net.msg_get_online_list_rep.decode(body);
    SingleCountEmitter.emit('S2C_MSG_GET_ONLINE_LIST_REP', msg);
  }

  msg_joingroup_byqrcode_rep(body, uin) {
    let msg = net.msg_joingroup_byqrcode_rep.decode(body);
    if (msg.result == 1) {
      SingleCountEmitter.emit('S2C_MSG_JOINGROUP_BYQRCODE_REP', msg);
    } else if (msg.result == net.RESULT_CODE.RESULT_CODE_GROUP_NEED_VERIFY) {
      console.log('该群已开启邀请确认模式，二维码已停用');
    } else if (msg.result == net.RESULT_CODE.RESULT_CODE_INVALID_GQRCODE) {
      console.log('非法二维码');
    } else {
      console.log('二维码已失效');
    }
  }

  msg_transfer_account_rep(body) {
    let msg = net.msg_transfer_account_rep.decode(body);
    SingleCountEmitter.emit('S2C_MSG_TRANSFER_ACCOUNT_REP', msg);
  }

  msg_get_pay_auth_code_rep(body) {
    let msg = net.msg_get_pay_auth_code_rep.decode(body);
    // console.log('msg_get_pay_auth_code_rep---->', msg);
    // if (msg.result == 1) {
    SingleCountEmitter.emit('S2C_MSG_GET_PAY_AUTH_CODE_REP', msg);
    // } else if (msg.result == 2) {
    //   console.log('非法手机号');
    // } else if (msg.result == 3) {
    //   console.log('手机号不存在');
    // } else if (msg.result == 4) {
    //   console.log('红包空了');
    // } else if (msg.result == 5) {
    //   console.log('已领取过该红包');
    // } else if (msg.result == 6) {
    //   console.log('不是好友');
    // } else if (msg.result == 7) {
    //   console.log('非法昵称');
    // } else if (msg.result == 8) {
    //   console.log('红包已过期');
    // } else if (msg.result == 9) {
    //   console.log('快捷登录已失效');
    // } else if (msg.result == 10) {
    //   console.log('余额不足');
    // } else if (msg.result == 11) {
    //   console.log('支付密码错误');
    // } else if (msg.result == 12) {
    //   console.log('非法授权');
    // } else if (msg.result == 13) {
    //   console.log('未设置密码');
    // }
  }
  msg_get_money_change_list_rep(body) {
    let msg = net.msg_get_money_change_list_rep.decode(body);
    console.log('msg_get_money_change_list_rep--->', msg);

    for (let index = 0; index < msg.money_list.length; index++) {
      msg.money_list[index].remarks = StringUtils.decode(
        msg.money_list[index].remarks,
      );
    }

    SingleCountEmitter.emit('S2C_MSG_GET_MONEY_CHANGE_LIST_REP', msg);
  }
  msg_get_my_goods_rep(body) {
    let msg = net.msg_get_my_goods_rep.decode(body);
    // console.log('msg_get_my_goods_rep--->', msg);
    SingleCountEmitter.emit('S2C_MSG_GET_MY_GOODS_REP', msg);
  }
  msg_create_goods_rep(body) {
    let msg = net.msg_create_goods_rep.decode(body);
    // console.log('msg_create_goods_rep--->', msg);
    if (msg.result == 1) {
      SingleCountEmitter.emit('S2C_MSG_CREATE_GOODS_REP', msg);
    } else if (msg.result == net.RESULT_CODE.RESULT_CODE_NO_PAYTYPE) {
      console.log('选中的支付方式未添加');
    } else if (msg.result == net.RESULT_CODE.RESULT_CODE_GOODS_NOT_ENOUGH) {
      console.log('商品金额不够');
    } else {
      console.log('提交失败，请稍后重试');
    }
  }
  msg_get_goods_rep(body) {
    let msg = net.msg_get_goods_rep.decode(body);
    // console.log('msg_get_goods_rep--->', msg);
    SingleCountEmitter.emit('S2C_MSG_GET_GOODS_REP', msg);
  }
  msg_create_order_rep(body) {
    let msg = net.msg_create_order_rep.decode(body);
    console.log('msg_create_order_rep--->', msg);
    // if (msg.result == 1) {
    SingleCountEmitter.emit('S2C_MSG_CREATE_ORDER_REP', msg);
    // } else if (msg.result == net.RESULT_CODE.RESULT_CODE_NO_PAYTYPE) {
    //   console.log('选中的支付方式未添加');
    // } else if (msg.result == net.RESULT_CODE.RESULT_CODE_GOODS_NOT_ENOUGH) {
    //   console.log('商品金额不够');
    // } else if (msg.result == net.RESULT_CODE.RESULT_CODE_HAS_UNFINISHED_ORDER) {
    //   console.log('与对方有未完成订单');
    // } else if (msg.result == net.RESULT_CODE.RESULT_CODE_NOT_SUPPORT_DEAL) {
    //   console.log('商品不支持该交易方式');
    // } else {
    //   console.log('创建订单失败,请稍后重试' + msg.result);
    // }
  }
  msg_confirm_order_rep(body) {
    let msg = net.msg_confirm_order_rep.decode(body);
    console.log('msg_confirm_order_rep--->', msg);
    if (msg.result == 1) {
      SingleCountEmitter.emit('S2C_MSG_CONFIRM_ORDER_REP', msg);
    } else if (msg.result == 18) {
      console.log('商品不存在');
    } else if (msg.result == 19) {
      console.log('订单不存在');
    } else {
      console.log('操作失败，请稍后重试');
    }
  }
  msg_get_my_orders_rep(body) {
    let msg = net.msg_get_my_orders_rep.decode(body);
    // console.log('msg_get_my_orders_rep--->', msg);
    SingleCountEmitter.emit('S2C_MSG_GET_MY_ORDERS_REP', msg);
  }
  msg_get_order_info_rep(body) {
    let msg = net.msg_get_order_info_rep.decode(body);
    console.log('msg_get_order_info_rep--->', msg);
    SingleCountEmitter.emit('S2C_MSG_GET_ORDER_INFO_REP', msg);
  }

  msg_withdraw_chatmsg_rep(body, uin) {
    let msg = net.msg_withdraw_chatmsg_rep.decode(body);
    SingleCountEmitter.emit('S2C_MSG_WITHDRAW_CHATMSG_REP', msg);
  }

  msg_get_goods_byid_rep(body) {
    let msg = net.msg_get_goods_byid_rep.decode(body);
    console.log('msg_get_goods_byid_rep--->', msg);
    SingleCountEmitter.emit('S2C_MSG_GET_GOODS_BYID_REP', msg);
  }

  msg_confirm_hasread_msg_rep(body, uin) {
    let msg = net.msg_confirm_hasread_msg_rep.decode(body);
    console.log('msg_confirm_hasread_msg_rep----->', msg);
    if (msg.chatmsgno_list.length > 0) {
      IMConversation.refreshMessageReadState(msg);
      SingleCountEmitter.emit('S2C_MSG_CONFIRM_HASREAD_MSG_REP', msg);
    }
  }
  msg_get_hasread_list_rep(body, uin) {
    let msg = net.msg_get_hasread_list_rep.decode(body);
    console.log('msg_get_hasread_list_rep----->', msg);
    if (msg.chatmsgno_list.length > 0) {
      for (let j = 0; j < msg.chatmsgno_list.length; j++) {
        for (let i = C2S.chatmsgno_list.length - 1; i >= 0; i--) {
          if (C2S.chatmsgno_list[i] == msg.chatmsgno_list[j]) {
            SingleCountEmitter.emit(
              'MSG_STATE_REFRESH' + msg.chatmsgno_list[j],
              4,
            );
            C2S.chatmsgno_list.splice(i, 1);
            break;
          }
        }
      }
      if (C2S.chatmsgno_list.length == 0) {
        C2S.cancelRequestUnread();
      }
      IMConversation.refreshMessageReadState(msg);
      SingleCountEmitter.emit('S2C_MSG_GET_HASREAD_LIST_REP', msg);
    }
  }

  msg_get_group_nickname_list_rep(body, uin) {
    let msg = net.msg_get_group_nickname_list_rep.decode(body);
    for (let i = 0; i < msg.name_list.length; i++) {
      msg.name_list[i].nickname = StringUtils.decode(msg.name_list[i].nickname);
    }

    IMGroups.setGroupNickName(msg.groupkey, msg.name_list);
  }

  msg_set_group_nickname_rep(body, uin) {
    let msg = net.msg_set_group_nickname_rep.decode(body);
    // console.log('msg_set_group_nickname_rep--------->', msg);
    let nickname = StringUtils.decode(msg.nickname);
    IMGroups.refreshGroupName(msg.groupkey, msg.uid, nickname);
    SingleCountEmitter.emit('S2C_MSG_SET_GROUP_NICKNAME_REP', msg);
  }

  msg_new_order_nty(body, uin) {
    let msg = net.msg_new_order_nty.decode(body);
    SingleCountEmitter.emit('S2C_MSG_NEW_ORDER_NTY', msg);
  }
  //取消订单
  msg_cancel_order_rep(body, uin) {
    let msg = net.msg_cancel_order_rep.decode(body);
    if (msg.result == 1) {
      // console.log('msg_cancel_order_rep--->', msg);
      SingleCountEmitter.emit('S2C_MSG_CANCEL_ORDER_REP', msg);
    } else if (msg.result == net.RESULT_CODE.RESULT_CODE_ORDER_NOT_EXIST) {
      console.log('订单不存在');
    } else if (msg.result == net.RESULT_CODE.RESULT_CODE_ORDER_COMPLETE) {
      console.log('订单已完成');
    }
  }
  msg_set_order_paytypeid_rep(body, uin) {
    let msg = net.msg_set_order_paytypeid_rep.decode(body);
    SingleCountEmitter.emit('S2C_MSG_SET_ORDER_PAYTYPEID_REP', msg);
  }
  msg_get_goods_data_rep(body, uin) {
    let msg = net.msg_get_goods_data_rep.decode(body);
    SingleCountEmitter.emit('S2C_MSG_GET_GOODS_DATA_REP', msg);
  }
  msg_get_goods_detail_data_rep(body, uin) {
    let msg = net.msg_get_goods_detail_data_rep.decode(body);
    SingleCountEmitter.emit('S2C_MSG_GET_GOODS_DETAIL_DATA_REP', msg);
  }
  msg_oper_shopcoin_rep(body, uin) {
    let msg = net.msg_oper_shopcoin_rep.decode(body);
    SingleCountEmitter.emit('S2C_MSG_OPER_SHOPCOIN_REP', msg);
  }

  msg_set_snapchat_rep(body, uin) {
    let msg = net.msg_set_snapchat_rep.decode(body);
    if (msg.result == 1) {

      SingleCountEmitter.emit('S2C_MSG_SET_SNAPCHAT_REP', msg);

      let m = IMApp.generateMsgOut(MessageType.CENTER_TIP, msg.snaptime == 0 ? '您关闭了阅后即焚' : '您开启了阅后即焚', msg.chatkey);
      SingleCountEmitter.emit('S2C_MSG_SEND_PRIVATE_MSG_REP', [m]);
    }
  }
  msg_get_snap_list_rep(body, uin) {
    let msg = net.msg_get_snap_list_rep.decode(body);
  }

  msg_get_group_member_list_rep(body, uin) {
    let msg = net.msg_get_group_member_list_rep.decode(body);

    let groupkey = msg.groupkey;
    /*
     IMGroups.getGroup(groupkey, group => {
       let users = [];
       for (let i = 0; i < msg.users.length; i++) {
         let u = IMApp.parseInfo(msg.users[i]);
         users.push(u);
       }
       IMUsers.addUserInfos(users);
       if (group) {
         if (msg.isfirst || !group.users) {
           group.users = [];
         }
         for (let i = 0; i < users.length; i++) {
           group.users.push(users[i]);
         }
         IMGroups.refreshGroup(groupkey, group, null);
 
         if (msg.isend == 1) {
           SingleCountEmitter.emit('S2C_MSG_GET_GROUP_MEMBER_LIST_REP', {
             groupkey: msg.groupkey,
           });
         }
       }
     });*/
  }

  msg_get_screenshot_rep(body, uin) {
    let msg = net.msg_get_screenshot_rep.decode(body);
  }

  msg_set_screenshot_rep(body, uin) {
    let msg = net.msg_set_screenshot_rep.decode(body);
    // console.log('msg_set_screenshot_rep msg--->', msg);
    if (msg.result == 1) {
      if (msg.uid == IMApp.user.uid) {
        SingleCountEmitter.emit('S2C_MSG_SET_SCREENSHOT_REP');
        let content = JSON.stringify({
          uid: IMApp.user.uid,
          screenshot: msg.screenshot,
        });
        C2S.msg_send_private_msg(
          msg.chatkey,
          MessageType.CENTER_TIP_SCREENSHOT_OPEN,
          content,
          IMApp.checkIsGroup(msg.chatkey),
        );
      }
    } else {
      console.log('设置失败');
    }
  }

  msg_set_groupsendmsg_limit_rep(body, uid) { }

  msg_get_order_info_byid_req(body, uin) {
    let msg = net.msg_get_order_info_byid_req.decode(body);
    // console.log('msg_get_order_info_byid_req------>', msg);
    if (msg.result == 1) {
      SingleCountEmitter.emit('S2C_MSG_GET_ORDER_INFO_BYID_REP', msg);
    } else {
      console.log('订单不存在');
    }
  }

  msg_rate_nty(body, uin) {
    let msg = net.msg_rate_nty.decode(body);
    // console.log('msg_rate_nty------->', msg);
    IMApp.ratelist = msg.ratelist;
    SingleCountEmitter.emit('S2C_MSG_RATE_NTY');
  }

  msg_set_black_list_rep(body, uin) {
    let msg = net.msg_set_black_list_rep.decode(body);
    if (msg.result == 1) {
      console.log(
        msg.opertype == 1 ? '已经将对方拉入黑名单' : '已解除黑名单',
      );
      C2S.msg_get_black_list();
      SingleCountEmitter.emit('SC2_MSG_SET_BLACK_LIST_REP', msg);
    } else {
      console.log('设置失败');
    }
  }
  msg_get_black_list_rep(body, uin) {
    let msg = net.msg_get_black_list_rep.decode(body);
    let list = [];
    for (let i = 0; i < msg.blacklist.length; i++) {
      list.push({ otheruid: msg.blacklist[i].uid, opertype: 1 });
    }

    IMApp.blackfriendlist = [];
    for (let i = 0; i < msg.blacklist.length; i++) {
      let d = IMApp.parseInfo(msg.blacklist[i]);
      IMApp.blackfriendlist.push(d);
    }
    SingleCountEmitter.emit('SC2_MSG_GET_BLACK_LIST_REP', msg.blacklist);
  }

  msg_third_pay_rep(body, uin) {
    let msg = net.msg_third_pay_rep.decode(body);
    SingleCountEmitter.emit('S2C_MSG_THIRD_PAY_REP', msg);
  }

  msg_pcauth_rep(body, uin) {
    let msg = net.msg_pcauth_rep.decode(body);
    SingleCountEmitter.emit('S2C_MSG_PCAUTH_REP', msg);
  }

  msg_voice_call_rep(body, uin) {
    let msg = net.msg_voice_call_rep.decode(body);
    SingleCountEmitter.emit('S2C_MSG_VOICE_CALL_REP', msg);
  }
  msg_oper_voice_call_rep(body, uin) {
    let msg = net.msg_oper_voice_call_rep.decode(body);
    // console.log('voice------->msg_oper_voice_call_rep-->', msg);
    if (msg.opertype == 1) {
      SingleCountEmitter.emit('JPUSH_VOICE_ACCEPT', msg);
    } else if (msg.opertype == 2) {
      SingleCountEmitter.emit('JPUSH_VOICE_LEAVEL', msg);
    }
  }

  msg_voice_call_nty(body, uin) {
    let msg = net.msg_voice_call_nty.decode(body);
    msg.token = StringUtils.decode(msg.token);
    if (msg.state == 2) {
      if (IMApp.isChatVoiceIng) {
      } else {
        C2S.msg_oper_voice_call(msg.chatkey, 2);
      }
    } else if (msg.state == 1 && !IMApp.isChatVoiceIng) {
      SingleCountEmitter.emit('S2C_MSG_VOICE_CALL_NTY', msg);
    }
  }
  msg_voice_data_nty(body, uin) {
    let msg = net.msg_voice_data_nty.decode(body);
    let detal = IMApp.getCurTime() * 1000 - msg.ptime;
  }

  msg_set_forbid_tm_rep(body, uin) {
    let msg = net.msg_set_forbid_tm_rep.decode(body);
    if (msg.result == 1) {
      SingleCountEmitter.emit('S2C_MSG_SET_FORBID_TM_REP', msg);
    }
  }

  msg_need_read_group_notify_rep(body, uin) {
    let msg = net.msg_need_read_group_notify_rep.decode(body);
    SingleCountEmitter.emit('S2C_MSG_NEED_READ_GROUP_NOTIFY_REP', msg);
  }

  msg_read_group_notify_rep(body, uin) {
    let msg = net.msg_read_group_notify_rep.decode(body);
    if (msg.result == 1) {
      SingleCountEmitter.emit('msg_read_group_notify_rep', msg);
    }
  }

  msg_friend_state_nty(body, uin) {
  }


}
